import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 3.75c0-.69.56-1.25 1.25-1.25h4.375c.69 0 1.25.56 1.25 1.25V10c0 .69-.56 1.25-1.25 1.25H3.75c-.69 0-1.25-.56-1.25-1.25V3.75Zm1.25 0h4.375V10H3.75V3.75ZM10.625 10c0-.69.56-1.25 1.25-1.25h4.375c.69 0 1.25.56 1.25 1.25v6.25c0 .69-.56 1.25-1.25 1.25h-4.375c-.69 0-1.25-.56-1.25-1.25V10Zm1.25 0h4.375v6.25h-4.375V10ZM3.75 12.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h4.375c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25H3.75Zm4.375 1.25H3.75v2.5h4.375v-2.5ZM10.625 3.75c0-.69.56-1.25 1.25-1.25h4.375c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-4.375c-.69 0-1.25-.56-1.25-1.25v-2.5Zm1.25 0h4.375v2.5h-4.375v-2.5Z",
      fill: "currentcolor"
    }, null, -1)
  ])))
}
export default { render: render }